const API_ROUTES = Object.freeze({
  POLYGON: "/api/polygon/",
});

const QUERY_KEYS = Object.freeze({
  POLYGON: "polygon",
  POLYGON_SELECTOR: "polygon-selector",
});

export { API_ROUTES, QUERY_KEYS };
